import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar";
import SupportFloatingActions from "./SupportFloatingActions";
import { Toaster } from "../ui/Toaster";

const SupportLayout = ({ setAuth, setUserOrg }) => (
  <div className="flex">
    <div className="h-[100dvh]">
      <div className="flex h-[100%] fixed top-0">
        <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
      </div>
    </div>
    <div
      className="pl-[10px] pr-[10px] flex flex-col w-full overflow-x-hidden pb-28"
      style={{
        marginLeft: "var(--sidebar-width, 250px)",
        width: "calc(100% - var(--sidebar-width, 250px))",
      }}
    >
      <Outlet />
      <Toaster />
    </div>
  </div>
);

export default SupportLayout;
